// extracted by mini-css-extract-plugin
export var dividerContainer = "_70-0";
export var line = "_70-1";